/* eslint-disable import/no-extraneous-dependencies */
import 'react-app-polyfill/ie11.js';
import 'url-search-params-polyfill';
import 'url-polyfill';
import 'whatwg-fetch';

import React from 'react';
import ReactDOM from 'react-dom';
import { enableES5 } from 'immer';
import {
    overrideComponent,
    postVerificationSizeUpdates,
    setMetadata,
    setOptions,
} from '@sheerid/jslib';
import { returnToWorkValidator } from './validators/customFieldValidators';
import { StepEmploymentPersonalInfoComponent } from './components/steps/StepEmploymentPersonalInfo';
import { StepSuccessComponent } from './components/steps/StepSuccessComponent';

import './index.css';
import App from './App';

import { defaultOptions } from './programOptions';
import { googleTagManagerHook } from './hooks/hooks';

// @ts-ignore
overrideComponent('StepEmploymentPersonalInfoComponent', StepEmploymentPersonalInfoComponent);
overrideComponent('StepSuccessComponent', StepSuccessComponent);

setOptions(defaultOptions);
googleTagManagerHook();
postVerificationSizeUpdates();
enableES5();
returnToWorkValidator();

setMetadata({
    returnToWork: '',
    communicationOptIn: true,
});


ReactDOM.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>,
    document.getElementById('root'),
);
